import { FC } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { GeneralButton } from "../../../common/ui/GeneralButton";

interface DownloadBtnProps {
  downloadUrl: string | null;
}

const DownloadBtn: FC<DownloadBtnProps> = ({
  downloadUrl,
}) => {
  return (
    <GeneralButton
      appVariant="icon"
      disabled={!downloadUrl}
      onClick={() => downloadUrl ? window.open(downloadUrl, '_blank') : console.error('No URL provided')}
    >
      <DownloadIcon />
    </GeneralButton>
  );
};

export default DownloadBtn;
